{
    "account": "계정",
    "add_bookmark": "북마크 메시지",
    "add_date": "날짜 추가",
    "ago": "{{duration}} 전",
    "api_key": "API 키",
    "are_you_sure": "확실하나요?",
    "ask_delete_message": "이 메시지를 삭제하겠습니까?",
    "audio_not_ready": "오디오가 아직 준비되지 않았습니다.",
    "bookmark_added": "북마크에 메시지가 추가되었습니다.",
    "bookmark_removed": "북마크에서 메시지가 제거되었습니다.",
    "bookmarks": "북마크",
    "cancel": "취소",
    "cancel_write": "새로운 메시지 작성을 취소하겠습니까?",
    "changed_group_name": "그룹 이름 변경됨",
    "confirm_password_placeholder": "비밀번호 확인",
    "connect": "연결",
    "create_a_group": "그룹 만들기",
    "create_the_group": "그룹 만들기",
    "daily": "일간",
    "default_group": "기본 그룹",
    "delete": "삭제",
    "destroy_account": "계정 삭제",
    "destroy_account_explain": "계정을 삭제하면 되돌릴 수 없습니다. 확인 해 주세요.",
    "edit": "편집",
    "email": "이메일",
    "email_input": "여기에 이메일 주소를 입력합니다",
    "empty_message": "메시지가 비어 있어 보낼 수 없습니다.",
    "error": "오류 발생",
    "error_new_message": "메시지를 보내는 동안 오류가 발생했습니다.",
    "error_upload": "업로드 중 오류 발생",
    "forgot_password": "비밀번호를 잊어버렸습니까?",
    "group_left": "그룹을 나갔습니다.",
    "groups": "그룹",
    "group_share_choice": "이 메시지를 어느 그룹에 보내시겠습니까?",
    "group_updated": "그룹이 업데이트되었습니다.",
    "has_commented_on": "댓글 등록됨",
    "has_joined": "가입됨",
    "has_left": "나갔음",
    "has_posted_in": "게시됨",
    "hourly": "매 시간",
    "in": "의",
    "Invalid login/password": "잘못된 로그인 및/또는 비밀번호",
    "invitation_link": "초대 링크",
    "invitation_welcome": "Zusam에 오신 것을 환영합니다. 그룹에 가입하기 전에 가입하세요.",
    "just_now": "지금 당장",
    "lang": "언어",
    "login": "로그인",
    "login_input": "로그인 선택",
    "login_placeholder": "이메일",
    "logout": "로그아웃",
    "mark_all_as_read": "모두 읽은 것으로 표시",
    "monthly": "월간",
    "multiple_photos_upload": "오류가 발생했습니다. 이미지를 하나씩 업로드해 보세요 (일부 브라우저에서 발생할 수 있음).",
    "name": "이름",
    "name_input": "이름 선택",
    "new_password_placeholder": "새로운 비밀번호",
    "next_coms": "다음 댓글 보기",
    "none": "없음",
    "notification_emails": "이메일 알림",
    "notification_emails_stopped": "이메일 알림이 중지되었습니다!",
    "notifications": "알림",
    "parent_message": "상위 메시지",
    "password": "비밀번호",
    "password_input": "여기에 새로운 비밀번호 작성",
    "password_placeholder": "비밀번호",
    "password_reset_mail_sent": "비밀번호 재설정 이메일이 전송되었습니다.",
    "passwords_dont_match": "비밀번호가 일치하지 않음",
    "previous_coms": "이전 댓글 보기",
    "public_link": "공개 링크",
    "publish_in_group": "그룹에 게시",
    "quit_group": "그룹 나가기",
    "remove_bookmark": "북마크 해제 메시지",
    "replies_one": "{{count}} 답글",
    "replies_other": "{{count}} 답글",
    "reply": "답글",
    "reset_api_key": "API 키 재설정 (연결이 끊어짐)",
    "reset_invitation_link": "초대 링크 재설정",
    "reset_password_title": "비밀번호 재설정",
    "save_changes": "변경 사항 저장",
    "search_in_group": "이 그룹에서 검색",
    "search_without_result": "검색어와 일치하는 메시지가 없습니다.",
    "settings": "설정",
    "settings_updated": "설정 업데이트됨",
    "share_message": "메시지 공유",
    "signup": "가입하기",
    "submit": "제출",
    "text_placeholder": "여기에 메시지 작성",
    "the_message_from": "메세지",
    "title_placeholder": "메시지 제목 (선택사항)",
    "to": "에",
    "upload_audio": "오디오 파일을 추가합니다.",
    "upload_image": "사진 추가",
    "upload_music": "음악 추가",
    "upload_pdf": "PDF 추가",
    "upload_video": "동영상 추가",
    "User not found": "사용자를 찾을 수 없음",
    "users": "사용자",
    "video_not_ready": "동영상이 아직 준비되지 않았습니다.",
    "weekly": "주간"
}
